
import { Component, Watch, Emit, Prop, Vue } from 'vue-property-decorator';
// @ is an alias to /src
import { fetchPostsPickup } from '@/services/userService';
import BoxPickup from '@/components/box/BoxPickup/BoxPickup.vue';
import $ from 'jquery';
import LoadingAnimation from "@/components/loading/LoadingAnimation.vue";

@Component({
  components: {
    BoxPickup,
    LoadingAnimation
  },
})
export default class HomePickuplist extends Vue {
  private name = 'homepickuplist';
  private firstItemsLength: number = 4;
  private length: number|null = 4;
  private offset: number = 0;
  private list: PostDataPickup[] = [];
  private totaleItems: number = 0;
  private isOpend = false;
  get primaryItem(): PostDataPickup {
    return this.list[0];
  }
  get secondaryItem(): PostDataPickup[] {
    const result = this.list.filter((element, index, array) => {
      if (index !== 0 && index < this.firstItemsLength) {
        return element;
      }
    });
    return result;
  }
  get moreItem(): PostDataPickup[] {
    const result = this.list.filter((element, index, array) => {
      if (index >= this.firstItemsLength) {
        return element;
      }
    });
    return result;
  }
  get showMore(): boolean {
    if (this.totaleItems > this.firstItemsLength) {
      return true;
    } else {
      return false;
    }
  }
  @Emit()
  private async showMoreItems() {
    if (this.length && this.length > 0) {
      this.length = null;
      await this.getEntries();
    }
    if (this.isOpend) {
      this.isOpend = false;
    } else {
      this.isOpend = true;
    }
    this.$nextTick(() => {
      if (!this.$refs.moreItems) return;
      const $moreItems: any = $(this.$refs.moreItems);
      if (this.isOpend) {
        $moreItems.stop().slideDown();
      } else {
        $moreItems.stop().slideUp();
      }
    });
  }
  @Emit()
  private setList(list: PostDataPickup[]) {
    this.list = list;
  }
  @Emit()
  private async getEntries() {
    let params: any = {
      offset: this.offset,
    }
    if (this.length) {
      params.length = this.length;
    }
    await fetchPostsPickup(params)
    .then( (response) => {
      this.totaleItems = Number(response.hits);
      this.setList(response.datas);
    })
    .catch( (e) => {
      console.error(e);
    });
  }
}
